/* eslint-disable */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationFR from "./locales/fr.json";
import translationAR from "./locales/ar.json";
import translationEN from "./locales/en.json";

const savedLanguage = localStorage.getItem("language") || "ar";

export const setDocumentDirection = () => {
  const currentLang = i18n.language;
  const direction = currentLang === "ar" ? "rtl" : "ltr";
  document.documentElement.dir = direction;
  document.body.dir = direction;
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: translationFR },
      ar: { translation: translationAR },
      en: { translation: translationEN },
    },
    lng:  savedLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on('languageChanged', (lng) => {
  setDocumentDirection();
});
setDocumentDirection();

export default i18n;
